// Mirrors AiDocumentFileTypes.Supported in Compass.Comtrack2.Core; the server enforces the same list.
export const AI_DOCUMENT_EXTENSIONS = [
    '.pdf', '.docx', '.html', '.htm', '.txt', '.csv', '.json', '.xml', '.md', '.eml',
    '.jpg', '.jpeg', '.png', '.heic'
];

export const AI_DOCUMENT_ACCEPT = AI_DOCUMENT_EXTENSIONS.join(',');

export const AI_BUNDLE_ACCEPT = ['.zip', ...AI_DOCUMENT_EXTENSIONS].join(',');

export const isAiDocumentFile = (fileName: string): boolean => {
    const dotIndex = fileName.lastIndexOf('.');
    return dotIndex >= 0 && AI_DOCUMENT_EXTENSIONS.includes(fileName.substring(dotIndex).toLowerCase());
};
